// 定义字段类型
export interface TagType {
  id: number
  tagName: string
  level: number
}

export enum ELKReportName {
  // 接口请求错误
  requestError = '接口请求错误',
  // 流式接口请求错误
  streamRequestError = '流式接口请求错误',
  // AI写作信息
  aiWritingInfo = 'AI写作信息',
  // AI文章生成时间
  aiArticleGenerateTime = 'AI文章生成时间',
  // AI图片信息
  aiImageInfo = 'AI图片信息',
  // AI封面生成错误
  aiCoverGenerateError = 'AI封面生成错误',
  // AI图片生成超时
  aiImageGenerateTimeout = 'AI图片生成超时',
  // 报错信息
  errorInfo = '报错信息',
  // 外部粘贴图片处理错误
  pasteImageError = '外部粘贴图片处理错误',
}
